module.exports = __webpack_public_path__ + "static/media/desktop.2ea1430d.png";